angular.module('impactx.MenuDirectives').directive('ixGlobalActions', function () {
    return {
        restrict: 'A',
        templateUrl: 'shared/menu/templates/global-actions-menu.tmpl.html'
    }
});